<script setup lang="ts">
import { useToasterStore } from '#imports'

interface Props {
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'top-center' | 'bottom-center'
}

const props = withDefaults(defineProps<Props>(), {
  position: 'bottom-right',
})

const store = useToasterStore()

const positionClasses = computed(() => {
  switch (props.position) {
    case 'top-left':
      return 'items-start justify-start'
    case 'top-center':
      return 'items-center justify-start'
    case 'top-right':
      return 'items-end justify-start'
    case 'bottom-left':
      return 'items-start justify-end'
    case 'bottom-center':
      return 'items-center justify-end'
    case 'bottom-right':
      return 'items-end justify-end'
    default:
      return 'items-end justify-start'
  }
})

const containerClasses = computed(() => {
  switch (props.position) {
    case 'top-left':
    case 'top-center':
    case 'top-right':
      return 'flex-col'
    case 'bottom-left':
    case 'bottom-center':
    case 'bottom-right':
      return 'flex-col-reverse'
    default:
      return 'flex-col'
  }
})

</script>

<template>
  <Teleport to="body">
    <div
      class="pointer-events-none fixed inset-0 z-[9999] flex flex-col items-end justify-start gap-4 p-4"
      :class="positionClasses"
    >
      <TransitionGroup
        name="toast"
        tag="div"
        class="flex flex-col gap-4"
        :class="containerClasses"
      >
        <ToasterItem
          v-for="toast in store.toasts"
          :key="toast.id"
          :toast="toast"
          @close="store.removeToast(toast.id)"
          @pause="store.pauseToast(toast.id)"
          @resume="store.resumeToast(toast.id)"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.toast-move {
  transition: transform 0.3s ease;
}
</style>
